package com.essntl.uikit.components.link

import kotlin.uuid.ExperimentalUuidApi
import kotlin.uuid.Uuid

@OptIn(ExperimentalUuidApi::class)
data class NavLinkState(
    val id: String = Uuid.random().toString(),
    val title: String,
    val isLoading: Boolean = false,
    val canPop: () -> Boolean = { true },
    val iconRes: String? = null,
    val iconUrl: String? = null,
    val isNavSidebarFixedByDefault: Boolean = true,
    val canRefresh: Boolean = true,
    val onRefresh: () -> Unit = {},
)